<template>
    <div>
        <p>
            <b-button
                v-b-tooltip.hover="{
                    variant: 'info',
                    title: 'Si les données précédentes ne sont pas mises à jour, cliquez ici pour actualiser le mapping',
                }"
                variant="outline-primary"
                @click="regenerateColumns">
                Actualiser les colonnes
            </b-button>
        </p>

        <b-table-simple small bordered class="mt-1">
            <b-thead>
                <b-tr>
                    <b-th>Colonne</b-th>
                    <b-th>Mapping</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(row, idx) in colonnes" :key="'mc' + idx">
                    <b-td>
                        <b-input v-model="row.colonne" :list="'mc-columns-' + id" size="sm" />
                        <b-form-datalist :id="'mc-columns-' + id" :options="columns_data" />
                    </b-td>
                    <b-td>
                        <b-input v-model="row.mapping" size="sm" />
                    </b-td>
                    <b-td>
                        <b-button size="sm" variant="danger" @click="colonnes.splice(idx, 1)">✕</b-button>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <b-button size="sm" @click="colonnes.push({ colonne: '', mapping: '' })">+ Mapping</b-button>

        <p class="mt-3">
            Séparateur
            <b-input v-model="separator" />
        </p>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "mapping_colonnes_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        data() {
            return {
                id: uniqueId(""),
                colonnes: [],
                separator: "",
                columns_data: []
            };
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0)
                        this.columns_data = Object.keys(this.data[0]);
                }
            }
        },
        methods: {
            regenerateColumns() {
                if (this.data.length === 0)
                    return;

                this.colonnes = Object.keys(this.data[0]).map((colonne) => ({
                    colonne,
                    mapping: colonne
                }));
            },
            save() {
                return {
                    colonnes: this.colonnes,
                    separator: this.separator
                };
            },
            async load(data) {
                if (!data) data = {};
                this.colonnes = Array.isArray(data.colonnes) ? data.colonnes : [];
                this.separator = data.separator || "";
            }
        }
    };
</script>

<style scoped>
</style>
